'use client'

import { type FC, useId } from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { type StoryblokMagazineNewsletterSubscriptionFormData } from './StoryblokMagazineNewsletterSubscriptionFormData'

export const StoryblokMagazineNewsletterSubscriptionEmailField: FC = () => {
  const inputId = useId()
  const helperId = useId()

  const intl = useIntl()

  const {
    formState: { errors },
    register,
  } = useFormContext<StoryblokMagazineNewsletterSubscriptionFormData>()

  const { required, ...inputProps } = register('emailAddress', {
    required: intl.formatMessage({ id: 'form.error.input.missing' }),
  })

  return (
    <FormControl error={Boolean(errors.emailAddress)} required={required}>
      <FormLabel htmlFor={inputId}>
        <FormattedMessage id="general.label.email" />
      </FormLabel>
      <Input
        aria-describedby={errors.emailAddress ? helperId : undefined}
        id={inputId}
        type="email"
        {...inputProps}
      />
      {errors.emailAddress ? (
        <FormHelperText id={helperId}>
          {errors.emailAddress.message}
        </FormHelperText>
      ) : null}
    </FormControl>
  )
}
